<div *ngIf="worksheet" class="mapping-worksheet-container">
  <div class="worksheet-name">{{ worksheet.name }}</div>
  <div class="worksheet-questionnaires">
    <div *ngFor="let questionnaire of worksheet.questionnaire; index as i">
      <div *ngIf="questionnaire" class="worksheet-details">
        <ng-container
          *ngTemplateOutlet="
            column;
            context: {
              type: 'question',
              questionnaire,
              index: i,
              focus: i === worksheet.questionnaire?.length - 1 && addQuestionnaireClicked
            }
          "
        ></ng-container>
        <div
          class="worksheet-question"
          tooltipPosition="top"
          [pTooltip]="'Question'"
          tooltipStyleClass="u-tooltip"
          [ngClass]="{
            opacity: !questionnaire.questionColumn?.address,
            'filled-question': questionnaire.questionColumn?.address
          }"
        >
          {{
            questionnaire.questionColumn?.address
              ? questionnaire.questionColumn?.header || questionnaireContent.undefinedColumn
              : questionnaireContent.headerPlaceholder
          }}
        </div>
        <ng-container *ngTemplateOutlet="column; context: { type: 'response', questionnaire, index: i }"></ng-container>
        <div
          class="worksheet-answer"
          tooltipPosition="top"
          [pTooltip]="'Answer'"
          tooltipStyleClass="u-tooltip"
          [ngClass]="{
            opacity: !questionnaire.responseColumn?.address,
            'filled-answer': questionnaire.responseColumn?.address
          }"
        >
          {{
            questionnaire.responseColumn?.address
              ? questionnaire.responseColumn?.header || questionnaireContent.undefinedColumn
              : questionnaireContent.headerPlaceholder
          }}
        </div>
        <div class="worksheet-action">
          <u-button
            *ngIf="i"
            type="secondary"
            fontIcon="delete"
            (onClick)="deleteQuestionnaire(i)"
            [pTooltip]="'Delete'"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          ></u-button>
          <u-button
            *ngIf="!i"
            type="secondary"
            (onClick)="addQuestionnaire()"
            fontIcon="plus"
            [pTooltip]="
              worksheet.questionnaire.length < questionnaireContent.maxQuestions ? 'Add' : questionnaireContent.maxQuestionsDescription
            "
            [disabled]="disabledAddButton"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          >
          </u-button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #column let-questionnaire="questionnaire" let-index="index" let-type="type" let-focus="focus">
  <u-input
    class="worksheet-column"
    [ngClass]="{
      'filled-input': type === 'response' ? questionnaire.responseColumn?.address : questionnaire.questionColumn?.address,
      'error-input': isErrorInput(questionnaire, type)
    }"
    (onChange)="updateColumn($event, type, index)"
    [model]="type === 'response' ? questionnaire.responseColumn?.address : questionnaire.questionColumn?.address"
    [placeholder]="questionnaireContent.columnPlaceholder"
    tooltipPosition="top"
    [pTooltip]="questionnaireContent.tooltipColumn"
    [inputFocus]="focus"
    tooltipStyleClass="u-tooltip"
  ></u-input>
</ng-template>
